/**
 * @generated SignedSource<<809280a4e7d768cc2a2d183141e6d8da>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardHeaderDropdown_view$data = {
  readonly columns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined>;
    readonly totalCount: number;
  };
  readonly id: string;
  readonly " $fragmentType": "BoardHeaderDropdown_view";
};
export type BoardHeaderDropdown_view$key = {
  readonly " $data"?: BoardHeaderDropdown_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardHeaderDropdown_view">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardHeaderDropdown_view",
  "selections": [
    {
      "kind": "RequiredField",
      "field": (v0/*: any*/),
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraBoardViewColumnConnection",
        "kind": "LinkedField",
        "name": "columns",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "totalCount"
            },
            "action": "THROW",
            "path": "columns.totalCount"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraBoardViewColumnEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "columns.edges"
          }
        ]
      },
      "action": "THROW",
      "path": "columns"
    }
  ],
  "type": "JiraBoardView"
};
})();

(node as any).hash = "fba614071e09a0790c888db7eb67278f";

export default node;
